import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllRoles = createAsyncThunk('roles/getAllRoles', async ({ page = 1, limit = 10 }, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/roles?limit=${limit}&page=${page}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const createNewRole = createAsyncThunk('roles/createNewRole', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/roles`, { ...payload });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateRole = createAsyncThunk(
  'roles/updateRole',
  async ({ role_name, description, id, location_id }, thunkAPI) => {
    try {
      const response = await axiosInstance.put(`/roles/${id}`, { role_name, description, location_id });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const deleteRoleById = createAsyncThunk('roles/deleteRoleById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/roles/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const assignUserRole = createAsyncThunk('roles/assignUserRole', async ({ user_id, role_id }, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/user-roles`, { user_id, role_id });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const editUserRole = createAsyncThunk('roles/editUserRole', async ({ user_id, role_id }, thunkAPI) => {
  try {
    const response = await axiosInstance.put(`/user-roles/user/${user_id}`, { role_id });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getRoleById = createAsyncThunk('roles/getRoleById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/roles/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
